import { pdfStyles } from "../styles";
import type { PdfContext } from "../types";
import { buildHeader } from "./header";
import { buildFooter } from "./footer";
import { buildLeftColumn } from "./leftColumn";
import { buildRightColumn } from "./rightColumn";
import { buildFormaSection } from "./formaSection";
import { buildLensesImageBlocks } from "./lensesImageBlock";

// IMPORTANTE: cada llamada devuelve un objeto + array nuevos. pdfmake muta
// internamente los `canvas` (cálculos de layout); compartir la misma referencia
// entre dos posiciones del documento rompe el segundo render.
const horizontalLine = (margin: [number, number, number, number]) => ({
  canvas: [
    { type: "line", x1: 0, y1: 0, x2: 785, y2: 0, lineWidth: 4, lineColor: "#000000" },
  ],
  margin,
});

// Construye el `docDefinition` completo de pdfmake a partir del contexto.
// La primera página se compone de:
//   1. Línea horizontal superior
//   2. Sección principal: leftColumn (35% prescripción+técnicos) | separador
//      vertical | rightColumn (65% lente y tratamientos)
//   3. Línea horizontal divisora
//   4. Sección forma (forma + calibre + DNP + bisel + código de barras)
//   5. Imagen de lentes + textos OD/OI overlay (absolutePosition)
export function buildDocDefinition(ctx: PdfContext) {
  return {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [28, 36, 28, 40],
    defaultStyle: { fontSize: 8 },

    header: buildHeader(ctx),
    footer: buildFooter(),

    content: [
      horizontalLine([0, 0, 0, 0]),
      {
        stack: [
          {
            fontSize: 8,
            columns: [
              buildLeftColumn(ctx),
              {
                canvas: [
                  { type: "line", x1: 0, y1: 0, x2: 0, y2: 240, lineWidth: 4, lineColor: "#000000" },
                ],
              },
              buildRightColumn(ctx),
            ],
          },
          horizontalLine([0, 0, 0, 8]),
          buildFormaSection(ctx),
        ],
      },
      ...buildLensesImageBlocks(ctx),
    ],

    styles: pdfStyles,
  };
}
